import { useState, useEffect, useRef } from 'react'
import { clientesApi } from '../api/notasVenta'
import { etiquetaCliente } from '../utils/cliente'

export default function BuscadorCliente({ value, onChange, placeholder = 'Buscar por nombre o CUIT...' }) {
  const [query, setQuery] = useState(value ? etiquetaCliente(value) : '')
  const [resultados, setResultados] = useState([])
  const [abierto, setAbierto] = useState(false)
  const [buscando, setBuscando] = useState(false)
  const timer = useRef(null)
  const ref = useRef(null)

  // Si el cliente lo eligen por otro lado (lupa, ⌘K), la casilla lo muestra.
  const [idMostrado, setIdMostrado] = useState(value?.id ?? null)
  if ((value?.id ?? null) !== idMostrado) {
    setIdMostrado(value?.id ?? null)
    setQuery(value ? etiquetaCliente(value) : '')
  }

  // Cerrar dropdown al hacer clic afuera
  useEffect(() => {
    const handler = (e) => { if (!ref.current?.contains(e.target)) setAbierto(false) }
    document.addEventListener('mousedown', handler)
    return () => document.removeEventListener('mousedown', handler)
  }, [])

  const buscar = (texto) => {
    setQuery(texto)
    if (texto.length < 2) { setResultados([]); return }
    clearTimeout(timer.current)
    timer.current = setTimeout(async () => {
      setBuscando(true)
      try {
        const { data } = await clientesApi.buscar(texto)
        setResultados(data.data || data)
        setAbierto(true)
      } catch { } finally { setBuscando(false) }
    }, 300)
  }

  const seleccionar = (cliente) => {
    setQuery(etiquetaCliente(cliente))
    setAbierto(false)
    onChange(cliente)
  }

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      <input
        style={styles.input}
        value={query}
        onChange={e => buscar(e.target.value)}
        onFocus={() => resultados.length > 0 && setAbierto(true)}
        placeholder={placeholder}
      />
      {buscando && <span style={styles.hint}>Buscando...</span>}
      {abierto && resultados.length > 0 && (
        <div style={styles.dropdown}>
          {resultados.map(c => (
            <div key={c.id} style={styles.item} onMouseDown={() => seleccionar(c)}>
              <strong>{etiquetaCliente(c)}</strong>
              {c.nombre_fantasia && c.nombre_fantasia !== c.nombre && <span style={styles.cuit}>{c.nombre_fantasia}</span>}
              <span style={styles.cuit}>{c.cuit} — Lista: {c.lista_precios || 'general'}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

const styles = {
  input: { width: '100%', padding: '0.5rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '0.9375rem', boxSizing: 'border-box' },
  hint: { position: 'absolute', right: '0.75rem', top: '0.55rem', fontSize: '0.75rem', color: '#94a3b8' },
  dropdown: { position: 'absolute', top: '100%', left: 0, right: 0, background: 'white', border: '1px solid #e2e8f0', borderRadius: '6px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)', zIndex: 100, height: '240px', overflowY: 'auto' },
  item: { padding: '0.625rem 0.875rem', cursor: 'pointer', borderBottom: '1px solid #f1f5f9', display: 'flex', flexDirection: 'column', gap: '2px' },
  cuit: { fontSize: '0.75rem', color: '#64748b' },
}
